import React from 'react';
import ReactECharts from 'echarts-for-react';

const LineChart = ({
  data = [],
  xLabels = [],
  lineColor = '#222',
  height = 400,
  tooltipFormatter
}) => {
  // Calculate max value and interval for yAxis
  const maxData = Array.isArray(data) && data.length > 0 ? Math.max(...data) : 100;
  let yInterval = 50;
  let yMax = maxData;
  if (maxData > 1500) {
    yInterval = 500;
    yMax = Math.ceil(maxData / 500) * 500;
  } else if (maxData > 1000) {
    yInterval = 200;
    yMax = Math.ceil(maxData / 200) * 200;
  } else if (maxData > 500) {
    yInterval = 100;
    yMax = Math.ceil(maxData / 100) * 100;
  } else if (maxData > 100) {
    yInterval = 50;
    yMax = Math.ceil(maxData / 50) * 50;
  } else if (maxData > 10) {
    yInterval = 10;
    yMax = Math.ceil(maxData / 10) * 10;
  } else {
    yInterval = 1;
    yMax = Math.ceil(maxData / 1) * 1;
  }
  // Optionally, make interval more dynamic
  if (yMax > 0) {
    const ticks = Math.min(Math.floor(yMax / yInterval), 10);
    if (ticks < 4) yInterval = Math.ceil(yMax / 4);
  }

  const xLabelInterval = xLabels.length > 10 ? 'auto' : 0;
  const option = {
    grid: { left: 50, right: 30, top: 30, bottom: 40 },

    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xLabels,
      axisLabel: {
        color: '#3D4744',
        fontFamily: 'Montserrat',
        fontSize: 12,
        margin: 8,
        interval: xLabelInterval,
        rotate: 0,
        showMaxLabel: true,
        showMinLabel: true

      },
      axisLine: { lineStyle: { color: '#3D4744' } },
      axisTick: { show: true },
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: yMax,
      interval: yInterval,
      splitLine: {
        show: true,
        lineStyle: {
          color: '#E5E8EC',
          type: 'dashed',
        },
      },
      axisLabel: {
        show: true,
        color: '#7B8494',
        fontFamily: 'Montserrat',
        fontSize: 14, // Increased font size for y-axis labels
        margin: 12,
      },
      axisLine: { show: false },
      axisTick: { show: false },
    },
    tooltip: {
      trigger: 'axis',
      formatter: tooltipFormatter
    },
    series: [
      {
        data,
        type: 'line',
        smooth: true,
        lineStyle: {
          color: lineColor,
          width: 1,
        },
        symbol: 'none',
      },
    ],
  };

  return <ReactECharts style={{ height, width: '100%' }} option={option} />;
};

export default LineChart;
